export const FETCH_MERCHANT_TOKEN_REQUEST = 'FETCH_MERCHANT_TOKEN_REQUEST'
export const FETCH_MERCHANT_TOKEN_SUCCESS = 'FETCH_MERCHANT_TOKEN_SUCCESS'
export const FETCH_MERCHANT_TOKEN_FALIURE = 'FETCH_MERCHANT_TOKEN_FALIURE'
